import * as React from 'react'

export type FormProps<T> = {
  form: HTMLFormElement
  additionalData?: any
  url?: string | undefined
  onSuccess?: (data: T) => void | undefined
  onError?: (data: T) => void | undefined
}

export const useForm = <T extends Object>({
  form,
  additionalData,
  url = undefined,
  onSuccess = undefined,
  onError = undefined,
}: FormProps<T>) => {
  const [status, setStatus] = React.useState('')
  const [statusCode, setStatusCode] = React.useState(undefined)
  const [message, setMessage] = React.useState('')

  const handleSubmit = (e: React.SyntheticEvent) => {
    if (form) {
      e.preventDefault()
      setStatus('loading')
      setMessage('')

      const formEndpoint = url || form.action
      const data = Array.from(form.elements)
        .filter((input: HTMLInputElement) => input.name)
        .reduce((obj, input: HTMLInputElement) => Object.assign(obj, { [input.name]: input.value }), {} as T)
      
      if (additionalData) {
        Object.assign(data, additionalData)
      }

      fetch(formEndpoint, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then(response => {
          setStatusCode(response.status)

          if (response.status !== 200) {
            throw new Error(response.statusText)
          }

          return response
        })
        .then(() => {
          if (onSuccess) {
            onSuccess(data)
          }

          setStatus('success')
        })
        .catch(err => {
          if (onError) {
            onError(data)
          }

          setMessage(err.toString())
          setStatus('error')
        })
    }
  }

  return { handleSubmit, status, statusCode, message }
}
